import { render, staticRenderFns } from "./EnvironmentalImpactSummary.vue?vue&type=template&id=31049644&scoped=true"
import script from "./EnvironmentalImpactSummary.vue?vue&type=script&lang=js"
export * from "./EnvironmentalImpactSummary.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentalImpactSummary.vue?vue&type=style&index=0&id=31049644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31049644",
  null
  
)

export default component.exports